import { Text } from '../../components/Text';
import { IconComponent } from '../../theme/Icons';
import { IThemeColor } from '../../theme/IThemeColor';

export interface IStatProps {
    label: string;
    value: number;
    Icon: IconComponent;
    iconColor: IThemeColor;
    'data-id'?: string;
}

export const Stat: React.FC<IStatProps> = ({ label, value, Icon, iconColor, 'data-id': dataId }) => {
    return (
        <div data-id={dataId} style={{display: 'flex', gap: 10, minWidth: '150px'}}>
            <Icon size="large" color={iconColor} />
            <div>
                <Text data-type="stat-value"><span style={{fontSize: 24, fontWeight: 'bold'}}>{value}</span></Text>
                <Text>{label}</Text>
            </div>
        </div>
    );
};
